import React from 'react'
import clsx from 'clsx'

// Cube
import { classToFComponent, type FCClassContext } from 'cube-react'

// Gov-br
import { Col, Row, BrButton } from '@govbr-ds/react-components'

import Sel from './styles-consts'
import Icons from '@/shared/AppIcons'

import DominioSelectView from './v-dominio-select'

import { FiltroScope } from '../analise-bulas.scope'

const styles = {
    lblFilter1: { alignItems: 'center' },
    lblFilter2: { marginLeft: '5pt' },
    pnlActions: { padding: '10px' },
    btnLimpar: { alignSelf: 'baseline', marginTop: '8pt' },
    btnBuscar: { alignSelf: 'baseline', marginTop: '8pt' },
    inpPeriodo: { alignSelf: 'stretch', flexGrow: 1 },

    flexCenteredLayout: { display: 'flex', alignItems: 'center' },
    flexGrow: { flexGrow: 1 }
} satisfies Record<string, React.CSSProperties>

export type FiltroProps = {
    className?: string
    scope: FiltroScope
}

class FiltroViewClass implements FCClassContext<FiltroProps> {
    scope!: FiltroScope

    render({ className, scope }: FiltroProps) {
        this.scope = scope

        const msgSelectPlaceHolder = 'Digite algo para pesquisar'

        return (
            <Row className={clsx(className)}>
                <Col>
                    <div className={Sel.brCard}>
                        <div className={Sel.brCardContent}>
                            <div
                                className={clsx(Sel.textUp02, Sel.textWeightSemiBold, Sel.dFlexV)}
                                style={styles.lblFilter1}
                            >
                                <img width={20} height={20} src={Icons.filterIconUrl} />
                                <span style={styles.lblFilter2}>Filtros</span>
                            </div>
                            <br />
                            <br />
                            <Row>
                                <Col>
                                    <DominioSelectView
                                        label="Princípios ativos (*)"
                                        placeholder={msgSelectPlaceHolder}
                                        scope={scope.principiosAtivos}
                                    />
                                </Col>
                                <Col>
                                    <DominioSelectView
                                        label="Fabricantes"
                                        placeholder={msgSelectPlaceHolder}
                                        scope={scope.fabricantes}
                                    />
                                </Col>
                                <Col>
                                    <DominioSelectView
                                        label="Medicamentos"
                                        placeholder={msgSelectPlaceHolder}
                                        scope={scope.medicamentos}
                                    />
                                </Col>
                                <Col>
                                    <DominioSelectView
                                        label="Reações"
                                        placeholder={msgSelectPlaceHolder}
                                        scope={scope.reacoes}
                                    />
                                </Col>
                            </Row>
                            <div className={clsx(Sel.dFlexV, Sel.flexColumnGapBase)}>
                                <div style={styles.flexGrow}>&nbsp;</div>
                                <BrButton secondary style={styles.btnLimpar} onClick={scope.onLimpar}>
                                    Limpar filtros
                                </BrButton>
                                <BrButton primary style={styles.btnBuscar} onClick={scope.onConsultar}>
                                    Buscar
                                </BrButton>
                            </div>
                        </div>
                    </div>
                </Col>
            </Row>
        )
    }
}

export default classToFComponent(FiltroViewClass)
